import * as React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

type Props = {
    value: string | null | undefined;
    disabled: boolean | null | undefined;
    onChange: FlowAnyFunction;
    inputName: string;
};

export default class NumericInput extends React.Component<Props> {
    increaseCounter = () => {
        // TODO StrictNullCheck : Try to remove "!"
        const newValue = parseInt(this.props.value!, 10) + 1;
        this.props.onChange(newValue.toString());
    };

    decreaseCounter = () => {
        // TODO StrictNullCheck : Try to remove "!"
        let value = parseInt(this.props.value!, 10);
        if (value > 1) {
            value -= 1;
            this.props.onChange(value.toString());
        }
    };

    render(): React.ReactElement {
        return (
            <TextField
                variant="standard"
                value={this.props.value}
                disabled={!!this.props.disabled}
                name={this.props.inputName}
                fullWidth={false}
                style={{ width: '75px' }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <KeyboardArrowUpIcon
                                className="e2e-increase-dynamic-value"
                                onClick={this.increaseCounter}
                                style={{ cursor: 'pointer' }}
                            />
                            <KeyboardArrowDownIcon
                                className="e2e-decrease-dynamic-value"
                                onClick={this.decreaseCounter}
                                style={{ cursor: 'pointer' }}
                            />
                        </InputAdornment>
                    ),
                }}
            />
        );
    }
}
